module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAZElEQVQokZWQSQ3AMAwE11UBBEIhhGEhBEIpFoGn38hyjq7kjzWzkm2A0kCR2RvXR05Lkm5BTYoYj3vDvfa7uZBIayFIe0InnZIGbwoxk+DabS+4P7iXX/D6hgDPhQReCS3CgD71blUHrxIDLQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_right.png
// module id = LGnP
// module chunks = 1